module.exports = __webpack_public_path__ + "static/img/case1_1.png";